import './App.css';
import { React, useState } from 'react';
import characterLevels from './stats';
import { set } from 'mongoose';

function App() {
  const [result, setResult] = useState([]);

  const properties = [
    'vigor',
    'mind',
    'endurance',
    'strength',
    'dexterity',
    'intelligence',
    'faith',
    'arcane',
  ];

  const formOne = {
    vigor: 0,
    mind: 0,
    endurance: 0,
    strength: 0,
    dexterity: 0,
    intelligence: 0,
    faith: 0,
    arcane: 0,
  };

  const formTwo = {
    vigor: 0,
    mind: 0,
    endurance: 0,
    strength: 0,
    dexterity: 0,
    intelligence: 0,
    faith: 0,
    arcane: 0,
  };

  const handleChangeFOne = (e, index) => {
    const formOneArr = Object.keys(formOne);
    const selectedIndex = formOneArr[index];

    formOne[selectedIndex] = Number(e.target.value);
  };

  const handleChangeFTwo = (e, index) => {
    const formTwoArr = Object.keys(formTwo);
    const selectedIndex = formTwoArr[index];

    formTwo[selectedIndex] = Number(e.target.value);
  };

  const handleClick = () => {
    //console.log('58 ', Object.values(formOne), Object.values(formTwo));
    const answer = characterLevels(Object.values(formOne), Object.values(formTwo));

    if (answer.every((a) => a.includes('NaN'))) {
      setResult(['Error, Make Sure Your Numbers are all good!']);
      return;
    }

    setResult(answer);
  };

  return (
    <div className='App'>
      <header className='App-header'>
        <center>Elden Ring Respeccer Bot</center>
      </header>
      <div className='introWrap'>
        <div className='intro'>
          In the below forms, enter in your build's stats and that of a more advanced
          player whom you wish to proportionally emulate. Then, go to Rennala with a
          larval tear and respecc accordingly.
        </div>
      </div>
      <div className='formRow'>
        <div className='formOne'>
          <form>
            Your Build:
            <form>
              {properties.map((e, i) => {
                return (
                  <div className='labeled' key={i}>
                    <br />
                    <label>{e}</label> &nbsp;
                    <input
                      key={i}
                      type='text'
                      onChange={(e) => handleChangeFOne(e, i)}
                    ></input>
                  </div>
                );
              })}
            </form>
          </form>
        </div>
        <div className='formTwo'>
          Build You Want to Emulate:
          <form>
            {properties.map((e, i) => {
              return (
                <div className='labeled' key={i}>
                  <br />
                  <label>{e}</label> &nbsp;
                  <input
                    type='text'
                    key={i}
                    onChange={(e) => handleChangeFTwo(e, i)}
                  ></input>
                </div>
              );
            })}
          </form>
        </div>
      </div>
      <div>
        <button onClick={() => handleClick()}>Submit</button>
      </div>
      {result.map((r, i) => {
        return <div key={i}>{r}</div>;
      })}

      <br />
      <br />
    </div>
  );
}

export default App;
